import { render, staticRenderFns } from "./AddImageIcon.vue?vue&type=template&id=1de8e703&scoped=true"
import script from "./AddImageIcon.vue?vue&type=script&lang=js"
export * from "./AddImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de8e703",
  null
  
)

export default component.exports